export default {"src":"/_next/static/media/flint.22ab7f93.svg","height":190,"width":190,"blurWidth":0,"blurHeight":0};